(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-section"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const toggleButtons = document.querySelectorAll('.toggle_cstm_button');
  const allContents = document.querySelectorAll('.inner_cstm_show');

  toggleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = content.classList.contains('show_cstm-show');

      // Close all open contents
      allContents.forEach(function (el) {
        el.style.display = 'none';
        el.classList.remove('show_cstm-show');
      });

      // Reset all toggle button texts
      toggleButtons.forEach(function (btn) {
        const textSpan = btn.querySelector('.myacc-morebtn');
        if (textSpan) textSpan.textContent = 'see more';
      });

      // Toggle the clicked one
      if (!isOpen) {
        content.style.display = 'block';
        content.classList.add('show_cstm-show');
        const textSpan = this.querySelector('.myacc-morebtn');
        if (textSpan) textSpan.textContent = 'see less';
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
